import React, { memo, ChangeEvent, useState } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { ButtonGroup } from 'transfix-ui/components/ButtonGroup'
import { MILEAGE_TYPE_OPTIONS } from 'apps/spot-quote-control-panel/constants/spotBiddingConfig'
import {
  RANGE_TYPE,
  IMileageCriteria,
  ISpotBiddingRule,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'
import { TextInput } from 'components/atoms'
import { initialRangeType } from '../../utils/initialRangeType'

interface IMileageProps {
  value?: RecursivePartial<IMileageCriteria>
  onChange(change: RecursivePartial<ISpotBiddingRule>): void
  error?: string
}

export const Mileage = memo<IMileageProps>(({ error, onChange, value }) => {
  const { rangeEnd = '', rangeStart = '' } = value || {}

  const [mileageType, setMileageType] = useState(initialRangeType(rangeStart, rangeEnd))

  const mileageTypeHandler = (rangeType: string) => {
    if (rangeType === RANGE_TYPE.less) {
      onChange({ mileageCriteria: { ...value, rangeStart: '' } })
    } else if (rangeType === RANGE_TYPE.more) {
      onChange({ mileageCriteria: { ...value, rangeEnd: '' } })
    }
    setMileageType(rangeType)
  }

  const setRangeEnd = ({ target: { value: miles } }: ChangeEvent<HTMLInputElement>) => {
    onChange({ mileageCriteria: { ...value, rangeEnd: miles } })
  }
  const setRangeStart = ({ target: { value: miles } }: ChangeEvent<HTMLInputElement>) => {
    onChange({ mileageCriteria: { ...value, rangeStart: miles } })
  }

  return (
    <div className='row'>
      <div className='col-md-6 col-xs-6'>
        <ButtonGroup
          value={mileageType}
          onChange={mileageTypeHandler}
          dataTest='modal-mileage-button'>
          {MILEAGE_TYPE_OPTIONS.map(option => (
            <Button key={option.label} value={option.value} size='large' fullWidth>
              {option.label}
            </Button>
          ))}
        </ButtonGroup>
      </div>
      <div className='col-md-6 col-xs-6'>
        {(mileageType === RANGE_TYPE.more || mileageType === RANGE_TYPE.between) && (
          <div className='col-md-6'>
            <TextInput
              label={mileageType === RANGE_TYPE.more ? 'More Than' : 'Starting'}
              placeholder='Enter miles'
              id='modal-more-than'
              onChange={setRangeStart}
              value={rangeStart || ''}
              large
              validationMessage={error}
              invalid={!!error}
              dataTest='modal-more-than'
            />
          </div>
        )}
        {(mileageType === RANGE_TYPE.less || mileageType === RANGE_TYPE.between) && (
          <div className='col-md-6'>
            <TextInput
              label={mileageType === RANGE_TYPE.less ? 'Less Than' : 'Ending'}
              placeholder='Enter miles'
              id='modal-less-than'
              onChange={setRangeEnd}
              value={rangeEnd || ''}
              large
              validationMessage={error}
              invalid={!!error}
              dataTest='modal-less-than'
            />
          </div>
        )}
      </div>
    </div>
  )
})
